<div class="dropdown">
	<button
		type="button"
		(click)="toggleDropDown()"
		[attr.aria-label]="tooltipText"
		class="icon-button"
		aria-haspopup="true"
		tooltipText="tooltipText"
		[ngbTooltip]="tooltipText"
	>
		@if (iconName) {
			<ea-icon name="{{ iconName }}"></ea-icon>
		}
		@if (!iconName) {
			<span class="fa fa-{{ faIconClass }} fa-lg icon-background"></span>
		}
	</button>

	<div
		[ngClass]="{
			active: isActive,
			'show-arrow': showArrow,
			'menu-dropdown': dropdownType === DROPDOWN_TYPES.Menu,
			'input-dropdown': dropdownType === DROPDOWN_TYPES.Input,
			left: orientation === DROPDOWN_ORIENTATION.Left,
			right: orientation === DROPDOWN_ORIENTATION.Right
		}"
		class="dropdown-content"
	>
		<ng-container *ngTemplateOutlet="dropDownContentTemplate"></ng-container>
	</div>
</div>
@if (isActive) {
	<ea-ui-overlay (close)="overlayClick()"></ea-ui-overlay>
}
